/**
=========================================================
* ClubOS - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// ClubOS components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const ATHELITE_URL = "https://athelites.netlify.app/";

function Footer() {
  return (
    <SoftBox component="footer" py={6}>
      <Grid container justifyContent="center">
        <Grid item xs={10} lg={8}>
          <SoftBox display="flex" justifyContent="center" flexWrap="wrap" mb={3}>
            {["Company", "About Us", "Team", "Product", "Blog", "Pricing"].map((label) => (
              <SoftBox key={label} mr={{ xs: 2, lg: 3, xl: 6 }}>
                <SoftTypography
                  component="a"
                  href={ATHELITE_URL}
                  target="_blank"
                  rel="noreferrer"
                  variant="body2"
                  color="secondary"
                >
                  {label}
                </SoftTypography>
              </SoftBox>
            ))}
          </SoftBox>
        </Grid>
        <Grid item xs={12} lg={8} sx={{ textAlign: "center" }}>
          <SoftBox
            display="inline-flex"
            alignItems="center"
            gap={1}
            px={3}
            py={1}
            sx={{
              background: "linear-gradient(135deg, #1a73e8 0%, #17c1e8 100%)",
              borderRadius: "2rem",
            }}
          >
            <SoftTypography
              variant="caption"
              fontWeight="bold"
              sx={{ color: "#fff", letterSpacing: "0.05em", fontSize: "0.75rem" }}
            >
              ⚡ Powered by
            </SoftTypography>
            <SoftTypography
              component="a"
              href={ATHELITE_URL}
              target="_blank"
              rel="noreferrer"
              variant="caption"
              fontWeight="bold"
              sx={{
                color: "#fff",
                letterSpacing: "0.08em",
                fontSize: "0.8rem",
                textDecoration: "none",
                "&:hover": { opacity: 0.85 },
              }}
            >
              AthElite Management
            </SoftTypography>
          </SoftBox>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default Footer;
